module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-head"
  }, [(_vm.groupList.length && _vm.moduleName !== 'productStock' && _vm.moduleName !== 'productApi') ? _c('el-select', {
    staticClass: "manager",
    attrs: {
      "size": "small",
      "popper-class": "custom-select"
    },
    model: {
      value: (_vm.manager),
      callback: function($$v) {
        _vm.manager = $$v
      },
      expression: "manager"
    }
  }, [_vm._l((_vm.groupList), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), _vm._v(" "), (_vm.isSummit) ? _c('div', {
    staticClass: "custom-select-option",
    on: {
      "click": _vm.openGroup
    }
  }, [_vm._v("分组管理")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm._t("allPro"), _vm._v(" "), (_vm.moduleName === 'productStock') ? _c('el-select', {
    staticClass: "stock",
    attrs: {
      "size": "small",
      "popper-class": "custom-select"
    },
    model: {
      value: (_vm.manager),
      callback: function($$v) {
        _vm.manager = $$v
      },
      expression: "manager"
    }
  }, _vm._l((_vm.groupList), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  })) : _vm._e(), _vm._v(" "), _vm._t("proClass"), _vm._v(" "), (['1', '2'].indexOf(_vm.belonger.belongerType) === -1 && _vm.moduleName !== 'productApi' && _vm.moduleName !== 'waitPurchaseApi' && _vm.moduleName !== 'waitInstockPurchase' && _vm.moduleName !== 'waitOutstock' && _vm.moduleName !== 'productStock' && _vm.moduleName !== 'waitProduce' && _vm.showScope) ? _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.closeFilter),
      expression: "closeFilter"
    }],
    staticClass: "scope"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("范围筛选")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请选择",
      "readonly": ""
    },
    on: {
      "focus": _vm.scopeFilter
    },
    model: {
      value: (_vm.userName),
      callback: function($$v) {
        _vm.userName = $$v
      },
      expression: "userName"
    }
  }, [(['3', '4'].indexOf(_vm.belonger.belongerType) === -1 && 　_vm.rangeType) ? _c('el-select', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend",
    model: {
      value: (_vm.belonger.isMain),
      callback: function($$v) {
        _vm.$set(_vm.belonger, "isMain", $$v)
      },
      expression: "belonger.isMain"
    }
  }, [_c('el-option', {
    key: "1",
    attrs: {
      "label": "负责",
      "value": 1
    }
  }), _vm._v(" "), (_vm.rangeType !== 1) ? _c('el-option', {
    key: "0",
    attrs: {
      "label": "协同",
      "value": 0
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.userName) ? _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": _vm.clearSelect
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropbox-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.scopeShow) ? _c('v-dropbox', {
    on: {
      "staff": _vm.staffSelect,
      "department": _vm.departmentSelect
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (['waitPurchaseApi', 'waitProduce'].indexOf(_vm.moduleName) > -1) ? _c('div', {
    staticClass: "wait-list-filter"
  }, [(_vm.belonger.belongerType === '1') ? [_c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("关联合同:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchAttr.contractLike),
      expression: "searchAttr.contractLike"
    }],
    staticClass: "vw-input",
    attrs: {
      "type": "text",
      "placeholder": "请输入合同名称或编号"
    },
    domProps: {
      "value": (_vm.searchAttr.contractLike)
    },
    on: {
      "change": function($event) {
        _vm.handleSelect($event, 'contractLike')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchAttr, "contractLike", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.searchAttr.contractLike) ? _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        _vm.clearValue('contractLike')
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("客户名称:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchAttr.customerLike),
      expression: "searchAttr.customerLike"
    }],
    staticClass: "vw-input",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键字"
    },
    domProps: {
      "value": (_vm.searchAttr.customerLike)
    },
    on: {
      "change": function($event) {
        _vm.handleSelect($event, 'customerLike')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchAttr, "customerLike", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.searchAttr.customerLike) ? _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        _vm.clearValue('customerLike')
      }
    }
  }) : _vm._e()])] : [_c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("缺货产品:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchAttr.productLike),
      expression: "searchAttr.productLike"
    }],
    staticClass: "vw-input",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键字"
    },
    domProps: {
      "value": (_vm.searchAttr.productLike)
    },
    on: {
      "change": function($event) {
        _vm.handleSelect($event, 'productLike')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchAttr, "productLike", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.searchAttr.productLike) ? _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        _vm.clearValue('productLike')
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.moduleName === 'waitPurchaseApi') ? _c('div', {
    staticClass: "form-item"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("供应商:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchAttr.supplierLike),
      expression: "searchAttr.supplierLike"
    }],
    staticClass: "vw-input",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键字"
    },
    domProps: {
      "value": (_vm.searchAttr.supplierLike)
    },
    on: {
      "change": function($event) {
        _vm.handleSelect($event, 'supplierLike')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchAttr, "supplierLike", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.searchAttr.supplierLike) ? _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        _vm.clearValue('supplierLike')
      }
    }
  }) : _vm._e()]) : _vm._e()]], 2) : _vm._e(), _vm._v(" "), _vm._t("archive"), _vm._v(" "), _vm._t("help"), _vm._v(" "), (_vm.moduleName !== 'waitPurchaseApi' && _vm.moduleName !== 'waitProduce') ? _c('div', {
    staticClass: "list-panel"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_c('v-switch', {
    attrs: {
      "value": _vm.advanced,
      "onText": "常用",
      "offText": "高级"
    },
    on: {
      "change": _vm.switchAdvanced
    }
  })], 1), _vm._v(" "), _vm._t("warningType"), _vm._v(" "), _vm._l((_vm.initValue), function(item) {
    return (item.searchItem === 1 && !_vm.advanced) ? _c('div', {
      staticClass: "form-item"
    }, [_c('v-filter', {
      attrs: {
        "item": item
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('ul', {
    staticClass: "payment"
  }, _vm._l((_vm.paymentStatus), function(item) {
    return _c('li', {
      staticClass: "item",
      class: {
        active: item.key === _vm.currentIndex
      },
      on: {
        "click": function($event) {
          _vm.handleType(item.key)
        }
      }
    }, [_vm._v(_vm._s(item.value))])
  }))]), _vm._v(" "), (['paymentApi', 'payPlan', 'waitOutstock', 'waitInstockPurchase'].indexOf(_vm.moduleName) === -1) ? _c('div', {
    staticClass: "filter sort"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.setSortShow = true
      }
    }
  }, [_vm._v("列表设置")])], 1) : _vm._e(), _vm._v(" "), (['paymentApi', 'payPlan', 'invoice', 'waitOutstock', 'waitInstockPurchase'].indexOf(_vm.moduleName) === -1) ? _c('div', {
    staticClass: "filter left"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "常用筛选设置",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('span', {
    staticClass: "title",
    on: {
      "click": function($event) {
        _vm.setFilterShow = true
      }
    }
  }, [_c('i', {
    staticClass: "web-icon-filter"
  })])])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.groupListShow) ? _c('group-list', {
    attrs: {
      "templateId": _vm.curTemplate ? _vm.curTemplate.key : ''
    },
    on: {
      "closeDialog": function($event) {
        _vm.groupListShow = false
      },
      "refresh": _vm.getSearchItem
    }
  }) : _vm._e(), _vm._v(" "), (_vm.setFilterShow) ? _c('set-filter', {
    attrs: {
      "type": _vm.type,
      "templateId": _vm.curTemplate ? _vm.curTemplate.key : ''
    },
    on: {
      "closeDialog": function($event) {
        _vm.setFilterShow = false
      },
      "refresh": _vm.getSearchItem
    }
  }) : _vm._e(), _vm._v(" "), (_vm.setSortShow) ? _c('set-sort', {
    attrs: {
      "sortArray": _vm.sortArray,
      "initValue": _vm.initValue,
      "templateId": _vm.curTemplate ? _vm.curTemplate.key : ''
    },
    on: {
      "closeDialog": function($event) {
        _vm.setSortShow = false
      },
      "refresh": _vm.filterSelect
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0afb686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/list-panel.vue
// module id = 1345
// module chunks = 82